import { defineSlotRecipe } from '@chakra-ui/react';

export const stickySpinnerSlotRecipe = defineSlotRecipe({
    slots: ['wrapper', 'spinner'],
    base: {
        wrapper: {
            position: 'absolute',
            bgColor: 'whiteAlpha.900',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 'docked',
            textAlign: 'center',
        },
        spinner: {
            position: 'sticky',
            top: '50%',
            mb: '10vh',
            boxShadow: 'xs',
            borderRadius: 'full',
            bgColor: 'white',
        },
    },
});
